import { render, staticRenderFns } from "./previwerImg.vue?vue&type=template&id=732c7a03&scoped=true"
import script from "./previwerImg.vue?vue&type=script&lang=js"
export * from "./previwerImg.vue?vue&type=script&lang=js"
import style0 from "./previwerImg.vue?vue&type=style&index=0&id=732c7a03&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732c7a03",
  null
  
)

export default component.exports